import { render, staticRenderFns } from "./doctor_list.vue?vue&type=template&id=3d1e69a8&"
import script from "./doctor_list.vue?vue&type=script&lang=js&"
export * from "./doctor_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports